import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(persist((set) => ({
    token: null, 
    user: null,
    originalAdminToken: null, // Tracks the admin token during impersonation
    originalAdminUser: null,  // Tracks the admin user details

    login: (token, user) => set({ token, user }),
    
    logout: () => set({ 
        token: null, 
        user: null, 
        originalAdminToken: null, 
        originalAdminUser: null 
    }),

    // Action to start impersonating an owner
    impersonate: (newToken, newUser, adminToken, adminUser) => set({
        token: newToken,
        user: newUser,
        originalAdminToken: adminToken,
        originalAdminUser: adminUser
    }),

    // Action to restore the admin session
    returnToAdmin: () => set((state) => ({
        token: state.originalAdminToken,
        user: state.originalAdminUser,
        originalAdminToken: null,
        originalAdminUser: null
    }))
}), { name: 'auth-storage' }));